var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPeople = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#people_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.917 12.333c2.797 0 5.268 1.466 7.036 3.716a1 1 0 0 1-1.505 1.312l-.068-.077-.282-.343c-1.437-1.666-3.256-2.608-5.181-2.608-2.054 0-3.987 1.072-5.464 2.951A1 1 0 1 1 .88 16.05c1.768-2.25 4.239-3.716 7.037-3.716m6.849 1.227a1 1 0 0 1 1.323-.5c1.337.605 2.525 1.557 3.513 2.748l.195.24.058.085a1 1 0 0 1-1.631 1.151c-.855-1.088-1.866-1.907-2.96-2.401a1 1 0 0 1-.498-1.323m.262-3.054a1 1 0 0 1-.89-1.791zm.639-4.256a2.75 2.75 0 0 0-1.529-2.465 1 1 0 0 1 .89-1.79 4.75 4.75 0 0 1 0 8.51l-.89-1.79a2.75 2.75 0 0 0 1.529-2.465m-3 0a4.75 4.75 0 1 1-9.5 0 4.75 4.75 0 0 1 9.5 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "people_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))));
SvgPeople.displayName = "SvgPeople";
export { SvgPeople as ReactComponent };
export default SvgPeople;